import {
	FETCH_SCORE_RULES_REQUEST,
	FETCH_SCORE_RULES_SUCCESS,
	FETCH_SCORE_RULES_FAIL,
	UPDATE_SCORE_RULE_REQUEST,
	UPDATE_SCORE_RULE_SUCCESS,
	UPDATE_SCORE_RULE_FAIL,
	FETCH_SCORE_RULE_REQUEST,
	FETCH_SCORE_RULE_SUCCESS,
	FETCH_SCORE_RULE_FAIL,
} from "../constants/scoreRule";

function fetchScoreRulesReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			scoreRules: {},
			error: null,
			scoreRuleUpdate: false,
		};
	}
	switch (action.type) {
		case FETCH_SCORE_RULES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SCORE_RULES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				scoreRules: action.payload,
			};
		case FETCH_SCORE_RULES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateScoreRuleReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_SCORE_RULE_REQUEST:
			return { loading: true };
		case UPDATE_SCORE_RULE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				scoreRuleUpdate: true,
			};
		case UPDATE_SCORE_RULE_FAIL:
			return { loading: false, status: "FAILED", scoreRuleUpdate: false };
		default:
			return state;
	}
}

function fetchScoreRuleReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			scoreRule: {},
			error: null,
			scoreRuleUpdate: false,
		};
	}
	switch (action.type) {
		case FETCH_SCORE_RULE_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SCORE_RULE_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				scoreRule: action.payload,
			};
		case FETCH_SCORE_RULE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

export {
	fetchScoreRulesReducer,
	updateScoreRuleReducer,
	fetchScoreRuleReducer,
};
